import {
  FactOpinionSorterFormData,
  SourceAnalysisOrganizerFormData,
  WordStudyFormData,
} from "@/types/models/Exportables.interface";

const SOURCE_ANALYSIS_OPTIONAL_FIELDS: (keyof SourceAnalysisOrganizerFormData)[] =
  [
    "intended_audience",
    "world_events",
    "evidence_of_bias",
    "excluded_topics",
    "reliability",
    "conclusion",
  ];

const WORD_STUDY_OPTIONAL_FIELDS: (keyof WordStudyFormData)[] = [
  "definition",
  "related_words",
];

const FACT_OPINION_OPTIONAL_FIELDS: (keyof FactOpinionSorterFormData)[] = [
  "statements",
];

export function getOptionalFieldsList(setiIdentifier: string | undefined) {
  switch (setiIdentifier) {
    case "primary_source_analysis":
      return SOURCE_ANALYSIS_OPTIONAL_FIELDS;
    case "word_study":
      return WORD_STUDY_OPTIONAL_FIELDS;
    case "fact_opinion":
      return FACT_OPINION_OPTIONAL_FIELDS;
    default:
      return [];
  }
}
